import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React, { Component } from 'react';
import moment from 'moment';
import { Box, Dialog, DialogActions, DialogContent as MuiDialogContent, DialogTitle, FormControl, Grid, IconButton, InputAdornment as MuiInputAdornment, Typography, withStyles } from '@material-ui/core';
import { Close as CloseIcon } from '@material-ui/icons';
import { KailonaButton, KailonaDateTimePicker, KailonaTextField } from '@kailona/ui';
import GridColumn from '../lib/GridColumn';
var DialogContent = withStyles({
  root: {
    height: '100%',
    margin: '0 20px 20px 20px',
    backgroundColor: '#FFFFFF',
    border: '1px solid #EAEAEA',
    borderRadius: '5px',
    paddingBottom: '25px'
  }
})(MuiDialogContent);
var InputAdornment = withStyles({
  root: {
    '& p': {
      fontSize: '10px',
      color: 'grey'
    }
  }
})(MuiInputAdornment);

var LabsEditModal = /*#__PURE__*/function (_Component) {
  _inherits(LabsEditModal, _Component);

  var _super = _createSuper(LabsEditModal);

  function LabsEditModal(props) {
    var _this;

    _classCallCheck(this, LabsEditModal);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "toggleModal", function (isOpen) {
      _this.setState({
        isOpen: isOpen
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onConfirm", function () {
      var newLabsData = {
        date: moment(_this.dateRef.current.value),
        leukocytes: _this.leukocytesRef.current.value,
        hemoglobin: _this.hemoglobinRef.current.value,
        platelets: _this.plateletsRef.current.value,
        lymphocytes: _this.lymphocytesRef.current.value,
        neutrophils: _this.neutrophilsRef.current.value,
        eosinophils: _this.eosinophilsRef.current.value,
        basophils: _this.basophilsRef.current.value,
        monocytes: _this.monocytesRef.current.value
      };
      var labsData = _this.props.labsData;

      _this.props.handleSave(Object.assign({}, labsData || {}, newLabsData));
    });

    _defineProperty(_assertThisInitialized(_this), "getValue", function (text) {
      if (!text || !text.split) {
        return text || '';
      }

      var _text$split = text.split(' '),
          _text$split2 = _slicedToArray(_text$split, 1),
          value = _text$split2[0];

      return value;
    });

    _this.state = {
      isOpen: false
    };
    _this.dateRef = /*#__PURE__*/React.createRef();
    _this.leukocytesRef = /*#__PURE__*/React.createRef();
    _this.hemoglobinRef = /*#__PURE__*/React.createRef();
    _this.plateletsRef = /*#__PURE__*/React.createRef();
    _this.lymphocytesRef = /*#__PURE__*/React.createRef();
    _this.neutrophilsRef = /*#__PURE__*/React.createRef();
    _this.eosinophilsRef = /*#__PURE__*/React.createRef();
    _this.basophilsRef = /*#__PURE__*/React.createRef();
    _this.monocytesRef = /*#__PURE__*/React.createRef();
    return _this;
  }

  _createClass(LabsEditModal, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _ref = this.props.labsData || {},
          date = _ref.date,
          leukocytes = _ref.leukocytes,
          hemoglobin = _ref.hemoglobin,
          platelets = _ref.platelets,
          lymphocytes = _ref.lymphocytes,
          neutrophils = _ref.neutrophils,
          eosinophils = _ref.eosinophils,
          basophils = _ref.basophils,
          monocytes = _ref.monocytes;

      return /*#__PURE__*/React.createElement(Dialog, {
        open: this.state.isOpen,
        onClose: function onClose() {
          return _this2.toggleModal(false);
        }
      }, /*#__PURE__*/React.createElement(DialogTitle, null, /*#__PURE__*/React.createElement(Box, {
        display: "flex",
        alignItems: "center"
      }, /*#__PURE__*/React.createElement(Box, {
        flexGrow: 1
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "h3"
      }, t('ehr', this.props.labsData ? 'Update Lab Results' : 'Add Lab Results'))), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(IconButton, {
        onClick: function onClick() {
          return _this2.toggleModal(false);
        }
      }, /*#__PURE__*/React.createElement(CloseIcon, null))))), /*#__PURE__*/React.createElement(DialogContent, null, /*#__PURE__*/React.createElement("form", null, /*#__PURE__*/React.createElement(Grid, {
        container: true
      }, /*#__PURE__*/React.createElement(FormControl, null, /*#__PURE__*/React.createElement(KailonaDateTimePicker, {
        inputRef: this.dateRef,
        id: "date",
        ariaLabel: t('ehr', 'Select Date/Time'),
        defaultValue: date ? moment(date) : null,
        disableFuture: true
      }))), /*#__PURE__*/React.createElement(Grid, {
        container: true,
        alignItems: "center"
      }, /*#__PURE__*/React.createElement(GridColumn, {
        className: "left-column",
        item: true
      }, /*#__PURE__*/React.createElement(FormControl, null, /*#__PURE__*/React.createElement(KailonaTextField, {
        inputRef: this.leukocytesRef,
        id: "leukocytes",
        className: "kailona-MuiTextField",
        label: t('ehr', 'Leukocytes'),
        defaultValue: this.getValue(leukocytes),
        InputProps: {
          endAdornment: /*#__PURE__*/React.createElement(InputAdornment, null, "10^3/\xB5l")
        }
      }))), /*#__PURE__*/React.createElement(GridColumn, {
        className: "right-column",
        item: true
      }, /*#__PURE__*/React.createElement(FormControl, null, /*#__PURE__*/React.createElement(KailonaTextField, {
        inputRef: this.hemoglobinRef,
        type: "number",
        id: "hemoglobin",
        className: "kailona-MuiTextField",
        label: t('ehr', 'Hemoglobin'),
        defaultValue: this.getValue(hemoglobin),
        InputProps: {
          endAdornment: /*#__PURE__*/React.createElement(InputAdornment, null, "g/dL")
        }
      })))), /*#__PURE__*/React.createElement(Grid, {
        container: true,
        alignItems: "center"
      }, /*#__PURE__*/React.createElement(GridColumn, {
        className: "left-column",
        item: true
      }, /*#__PURE__*/React.createElement(FormControl, null, /*#__PURE__*/React.createElement(KailonaTextField, {
        inputRef: this.plateletsRef,
        type: "number",
        id: "platelets",
        className: "kailona-MuiTextField",
        label: t('ehr', 'Platelets'),
        defaultValue: this.getValue(platelets),
        InputProps: {
          endAdornment: /*#__PURE__*/React.createElement(InputAdornment, null, "10^3/\xB5l")
        }
      }))), /*#__PURE__*/React.createElement(GridColumn, {
        className: "right-column",
        item: true
      }, /*#__PURE__*/React.createElement(FormControl, null, /*#__PURE__*/React.createElement(KailonaTextField, {
        inputRef: this.lymphocytesRef,
        type: "number",
        id: "lymphocytes",
        className: "kailona-MuiTextField",
        label: t('ehr', 'Lymphocytes'),
        defaultValue: this.getValue(lymphocytes),
        InputProps: {
          endAdornment: /*#__PURE__*/React.createElement(InputAdornment, null, "10^3/\xB5l")
        }
      })))), /*#__PURE__*/React.createElement(Grid, {
        container: true,
        alignItems: "center"
      }, /*#__PURE__*/React.createElement(GridColumn, {
        className: "left-column",
        item: true
      }, /*#__PURE__*/React.createElement(FormControl, null, /*#__PURE__*/React.createElement(KailonaTextField, {
        inputRef: this.neutrophilsRef,
        type: "number",
        id: "neutrophils",
        className: "kailona-MuiTextField",
        label: t('ehr', 'Neutrophils'),
        defaultValue: this.getValue(neutrophils),
        InputProps: {
          endAdornment: /*#__PURE__*/React.createElement(InputAdornment, null, "10^3/\xB5l")
        }
      }))), /*#__PURE__*/React.createElement(GridColumn, {
        className: "right-column",
        item: true
      }, /*#__PURE__*/React.createElement(FormControl, null, /*#__PURE__*/React.createElement(KailonaTextField, {
        inputRef: this.eosinophilsRef,
        type: "number",
        id: "eosinophils",
        className: "kailona-MuiTextField",
        label: t('ehr', 'Eosinophils'),
        defaultValue: this.getValue(eosinophils),
        InputProps: {
          endAdornment: /*#__PURE__*/React.createElement(InputAdornment, null, "10^3/\xB5l")
        }
      })))), /*#__PURE__*/React.createElement(Grid, {
        container: true,
        alignItems: "center"
      }, /*#__PURE__*/React.createElement(GridColumn, {
        className: "left-column",
        item: true
      }, /*#__PURE__*/React.createElement(FormControl, null, /*#__PURE__*/React.createElement(KailonaTextField, {
        inputRef: this.basophilsRef,
        type: "number",
        id: "basophils",
        className: "kailona-MuiTextField",
        label: t('ehr', 'Basophils'),
        defaultValue: this.getValue(basophils),
        InputProps: {
          endAdornment: /*#__PURE__*/React.createElement(InputAdornment, null, "10^3/\xB5l")
        }
      }))), /*#__PURE__*/React.createElement(GridColumn, {
        className: "right-column",
        item: true
      }, /*#__PURE__*/React.createElement(FormControl, null, /*#__PURE__*/React.createElement(KailonaTextField, {
        inputRef: this.monocytesRef,
        type: "number",
        id: "Monocytes",
        className: "kailona-MuiTextField",
        label: t('ehr', 'Monocytes'),
        defaultValue: this.getValue(monocytes),
        InputProps: {
          endAdornment: /*#__PURE__*/React.createElement(InputAdornment, null, "10^3/\xB5l")
        }
      })))))), /*#__PURE__*/React.createElement(DialogActions, null, /*#__PURE__*/React.createElement(KailonaButton, {
        title: t('ehr', 'Cancel'),
        class: "default",
        disabled: this.props.savingLabs,
        onClick: function onClick() {
          return _this2.toggleModal(false);
        }
      }), /*#__PURE__*/React.createElement(KailonaButton, {
        title: t('ehr', 'Confirm'),
        class: "primary",
        disabled: this.props.savingLabs,
        onClick: this.onConfirm,
        loading: this.props.savingLabs
      })));
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return LabsEditModal;
}(Component);

export { LabsEditModal as default };
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(DialogContent, "DialogContent", "/home/runner/html/nextcloud/apps/ehr/js/plugins/laboratory/src/components/LabsEditModal.js");
  reactHotLoader.register(InputAdornment, "InputAdornment", "/home/runner/html/nextcloud/apps/ehr/js/plugins/laboratory/src/components/LabsEditModal.js");
  reactHotLoader.register(LabsEditModal, "LabsEditModal", "/home/runner/html/nextcloud/apps/ehr/js/plugins/laboratory/src/components/LabsEditModal.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();